import React from 'react';
import { BellIcon } from '@heroicons/react/24/outline';
import { BellIcon as BellIconSolid } from '@heroicons/react/24/solid';
import { useNotifications } from '../../hooks/useNotifications';
import { useNotificationCenter } from '../../contexts/NotificationContext';

const NotificationButton: React.FC = () => {
  const { getStats } = useNotifications();
  const { toggleNotifications } = useNotificationCenter();
  const stats = getStats();

  return (
    <button
      onClick={toggleNotifications}
      className="relative p-2 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
    >
      {stats.unread > 0 ? (
        <BellIconSolid className="h-6 w-6" />
      ) : (
        <BellIcon className="h-6 w-6" />
      )}
      
      {/* Értesítés számláló */}
      {stats.unread > 0 && (
        <span className="absolute -top-1 -right-1 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-red-500 rounded-full min-w-[18px] h-[18px]">
          {stats.unread > 99 ? '99+' : stats.unread}
        </span>
      )}
    </button>
  );
};

export default NotificationButton;
